import type { FaireProductEntity } from "../../entity_types/product";

export const p_eohf1k4b: FaireProductEntity = {
  token: "p_eohf1k4b",
  type: "product",
  name: "Nice Jewish Boy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/16bee0918e2fb7aea2dc216b1c2e2cc01abdd09bba363f74bdb082e677eef0ee/1535410119.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/975fe0c8cc3445f77633baf160ce0d4f64df3d82fda2eca4f25d8002242c4df5.jpeg",
    "https://cdn.faire.com/fastly/9b6d80239081c7caba63954adf4a87df57be7dcc077f165e19c9638834c05323.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/bd8e94777e3f4cc865e9eb91c8e4fc79b5f2d976d5c2a6b3428ac5d928be421c.jpeg",
    "https://cdn.faire.com/fastly/4be0818e608efbc24b0f17abb131703d62b18fca515165ad6762c7a5364cbdb6.jpeg",
    "https://cdn.faire.com/fastly/6ec8c0e791f4a67c8564944d1e914b901db8c009fb5109bae39fb7b8de3a378b.jpeg",
    "https://cdn.faire.com/fastly/e451530369ca7e78c37112cc9a34ac8b5d075c7f073650512161fc1972b3a0be.jpeg",
    "https://cdn.faire.com/fastly/09711e8965a30b8b0f95699ecfd6b44f43c6ae6be4ac14b67405cade18ccc478.jpeg"
  ],
  priceDollars: 6.75,
  description: "It's every mother’s dream - Jewish or Goy - for their daughter to marry a Nice Jewish Boy! Don’t get cold feet, now… We’re here to help with that.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:14.217Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
